"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _reactDom = require("react-dom");

require("./snackbar.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Snackbar(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      label = props.label,
      timeout = props.timeout,
      className = props.className;
  var containerClassName = (0, _classnames.default)("fixed inset-x-0 bottom-0 w-full px-4 py-6 bg-primary flex justify-between text-sm items-center", className);
  (0, _react.useEffect)(function () {
    if (isOpen && timeout) {
      var tid = setTimeout(function () {
        return onClose();
      }, timeout);
      return function () {
        return clearTimeout(tid);
      };
    }
  }, [isOpen, onClose, timeout]);
  return (0, _reactDom.createPortal)(_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: isOpen,
    timeout: 500,
    classNames: "snackbar",
    appear: true,
    unmountOnExit: true
  }, _react.default.createElement("div", {
    className: containerClassName
  }, _react.default.createElement("div", {
    className: "text-white pr-4"
  }, label), _react.default.createElement("div", {
    className: "font-bold uppercase cursor-pointer text-white",
    onClick: onClose
  }, "Dismiss"))), document.body);
}

Snackbar.propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  className: _propTypes.default.string
};
Snackbar.defaultProps = {
  label: '',
  className: ''
};

var _default = _react.default.memo(Snackbar);

exports.default = _default;